var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaVitalzeichen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ee7e3e;}.cls-3{fill:#ea5c0b;}.cls-4{fill:#fff;}.cls-5{fill:#c7cfe2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.44,58.05a33.06,33.06,0,0,1,66.11,0,33.06,33.06,0,0,1,66.12,0c0,41.88-66.12,77-66.12,77S13.44,97.92,13.44,58.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.67,58.05a33.06,33.06,0,0,0-66.12,0v77S145.67,99.92,145.67,58.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.55,108.42a3.45,3.45,0,0,1-3.09-1.91L56.7,67,48.38,83.66a3.47,3.47,0,0,1-3.1,1.91H11a3.46,3.46,0,0,1,0-6.92H43.14L53.61,57.72a3.45,3.45,0,0,1,6.19,0l19.49,39L90.9,69.34a3.47,3.47,0,0,1,6-.69l7.27,10h43.93a3.46,3.46,0,1,1,0,6.92H102.4a3.47,3.47,0,0,1-2.8-1.42l-4.71-6.48L82.74,106.31a3.49,3.49,0,0,1-3.08,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148.09,78.65H104.16l-7.27-10a3.47,3.47,0,0,0-6,.69L79.55,96.09v12.33h.11a3.49,3.49,0,0,0,3.08-2.11L94.89,77.67l4.71,6.48a3.47,3.47,0,0,0,2.8,1.42h45.69a3.46,3.46,0,1,0,0-6.92Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaVitalzeichen);
export default __webpack_public_path__ + "static/media/ka_vitalzeichen.db23ea3a030328331fcfe153e6366562.svg";
export { ForwardRef as ReactComponent };